import viewTransitionNavUtility from "@Utils/viewTransitionNavUtility";

export const navigateTo = (history: any, link: string, withAnimation = true) => {
  if (withAnimation)
    viewTransitionNavUtility(() => {
      history.push(link);
    }, "right-to-left");
  else history.push(link);
};
export default navigateTo;
